import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Layout from '../../components/common/Layout/Layout';
import { BRAND } from '../../config/brand';

export default function MenRedirect() {
  const BRAND_NAME = BRAND?.name || 'Luvia';
  const SITE_URL = BRAND?.url || process.env.REACT_APP_SITE_URL || 'https://theluviajewels.com';
  const pageTitle = `Women's Jewelry Only | ${BRAND_NAME}`;
  const pageDesc = `${BRAND_NAME} currently offers women's jewelry only. Explore rings, earrings, necklaces, bracelets and more.`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDesc} />
        <link rel="canonical" href={`${SITE_URL}/men`} />
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Layout>
        <main className="men-redirect" id="main-content">
          <section className="men-redirect__section" aria-labelledby="men-redirect-title">
            <p className="men-redirect__eyebrow">Store update</p>
            <h1 id="men-redirect-title" className="men-redirect__title">
              We currently design only for women
            </h1>
            <p className="men-redirect__body">
              You may have followed a link for men&apos;s jewelry. {BRAND_NAME} is focused on
              women&apos;s collections right now — rings, earrings, necklaces, bracelets and more.
            </p>
            <div className="men-redirect__actions" aria-label="Browse women&apos;s collections">
              <Link to="/women" className="men-redirect__btn men-redirect__btn--primary">
                Shop Women&apos;s Jewelry
              </Link>
              <Link to="/shop/women/rings" className="men-redirect__btn men-redirect__btn--ghost">
                Explore Rings
              </Link>
            </div>
          </section>
        </main>
      </Layout>
    </>
  );
}

